import { Alert, AlertColor } from '@mui/material';
import React, { useEffect } from 'react';

type CustomAlertType = {
	message: string;
	severity: AlertColor;
	closeTime?: number;
};

interface Props {
	alert: CustomAlertType;
	setAlert: (data: CustomAlertType) => void;
}

const CustomAlert = ({ alert, setAlert }: Props) => {
	useEffect(() => {
		setTimeout(() => {
			setAlert({ message: '', severity: 'success' });
		}, alert?.closeTime || 3000);
	}, []);

	return (
		<Alert
			sx={{
				position: 'absolute',
				right: '2%',
				top: '2%',
				zIndex: '1301',
				height: 'auto',
				width: '295px',
				background: alert?.severity === 'success' ? '#4CAF50' : null,
				borderRadius: '4px',
			}}
			variant="filled"
			severity={alert?.severity}
		>
			{alert?.message}
		</Alert>
	);
};

export default CustomAlert;
